import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { ProvideAuth, useAuth } from 'auth';
import { Loading } from 'components';

import LoginLayoutRoute from "layout/loginLayout";
import DashboardLayoutRoute from "layout/dashboardLayout";

import { Login } from 'auth';
import { Orders } from './site/ecm/orderList/orders';
import { OrderDetails } from './site/ecm/orderDetails/orderDetails';
import { Products } from './site/ecm/productList/productList';
import { ProductEdit } from './site/ecm/productEdit/productEdit';
import { ProductNew } from './site/ecm/productNew/productNew';
import { Categories } from './site/ecm/categoryList/categories';
import { CategoryNew } from './site/ecm/categoryNew/categoryNew';
import { CategoryEdit } from './site/ecm/categoryEdit/categoryEdit';


import { ReIndex } from './site/reindex/reindex';
function App() {
  return (
    <ProvideAuth>
      <Router>
        <Switch>
          
          <DashboardLayoutRoute path="/admin/orders" component={Orders} />
          <DashboardLayoutRoute path="/admin/order/:id" component={OrderDetails} />
          
          <DashboardLayoutRoute path="/admin/products" component={Products} />
          <DashboardLayoutRoute path="/admin/product/new" component={ProductNew} />
          <DashboardLayoutRoute path="/admin/product/:id" component={ProductEdit} />
          <DashboardLayoutRoute path="/admin/categories" component={Categories} />
          <DashboardLayoutRoute path="/admin/category/new" component={CategoryNew} />
          <DashboardLayoutRoute path="/admin/category/:id" component={CategoryEdit} />
         

          <DashboardLayoutRoute path="/admin/reindex" component={ReIndex} />
          <LoginLayoutRoute path="/admin/login" component={Login} />   
          <Route exact path="/admin/dashboard">
            <Redirect to="/admin/orders" />
          </Route>
          
          <Route path="/">
            <Home/>
            </Route>
        </Switch>
      </Router>
    </ProvideAuth>
  );
}

function Home() {
  const auth = useAuth();

  if (!auth.isResolved) return <Loading/>;
  else if (auth.user) return <Redirect to="/admin/orders" />
  else return <Redirect to="/admin/login" />
}

export default App;